import About from '../components/About'
import IntroSection from '../components/IntroSection'
import ProcessSection from '../components/ProcessSection'
import ProfileSection from '../components/ProfileSection'
import Projects from '../components/Projects'

const Home = () => {
  

  return (
    <main className='main pt-[5rem] md:pt-[6.5rem] lg:pt-[8rem] px-6 xl:px-[4rem] xl:max-w-[90rem] xl:mx-auto'>
        <IntroSection/>
        <ProfileSection  />
        <About/>
        <ProcessSection/>
        <Projects/>
    </main>
  )
}

export default Home